// PXCO JS UTILITITES
var pxco = pxco || {};

pxco.extend = function (to, from) {
	for (var n in from) {
		if(!from.hasOwnProperty(n))
			continue;

		if (typeof to[n] != 'object' || to[n].nodeType !== 'undefined') {
			to[n] = from[n];
		} else if (typeof from[n] == 'object') {
			to[n] = pxco.extend(to[n], from[n]);
		}
	}
	return to;
};

pxco.build = {};

pxco.events = {
	set: function (obj, type, details) {
		var details = typeof details !== 'undefined' ? details : {};
		if (window.CustomEvent) {
			var myEvent = new CustomEvent(type, details)
		} else {
			var myEvent = document.createEvent('CustomEvent');
			myEvent.initCustomEvent(type, true, true, details);
		}
		obj.el.dispatchEvent(myEvent);
	},
	get: function (obj, prefix) {
		var prefix = typeof prefix !== 'undefined' ? prefix + ':' : '';
		for (var event in obj.events) {
			this.listen(obj, prefix + event, obj.events[event])
		}
	},
	listen: function (obj, eventName, callback) {
		obj.el.addEventListener(eventName, function (e) {
			callback(e, obj);
		});
	}
};

pxco.breakpoints = {
	init: function () {
		this.value = window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content').replace(/\"/g, '');
	}
};

pxco.fnLoad = function (fn) {
	if (pxco[fn]) {

		pxco[fn].init();
		
		window.addEventListener("resize", function () {
			pxco[fn].init();
		});
	}
};
pxco.fnLoad('breakpoints');